import axios from "../utils/axios";

export const getSparePartList = (payload) => {
  return axios.get(
    `/SpareParts?PageSize=${payload.pageSize}&PageNumber=${payload.currentPage}&Sorting.PropertyName=${payload.propertyName}&Sorting.Direction=${payload.direction}&Search=${payload.searchText}`
  );
};

export const getSparePartLogList = (payload) => {
  return axios.get(`/SpareParts/GetSparePartLogs?SparePartId=${payload.id}`);
};

export const getSparePartUsageList = (payload) => {
  return axios.post(
    `/UnplannedMaintenance/tasks/spare-parts/search?PageSize=${payload.pageSize}&PageNumber=${payload.currentPage}`,
    payload.data
  );
};

export const getSparePartUsagePlannedList = (payload) => {
  return axios.post(
    `/PlannedMaintenance/tasks/spare-parts/search?PageSize=${payload.pageSize}&PageNumber=${payload.currentPage}`,
    payload.data
  );
};

export const getSelectedSparePartListUnplanned = (taskId) => {
  return axios.get(`/UnplannedMaintenance/GetSparePartsList?taskId=${taskId}`);
};

export const getSelectedSparePartListPlanned = (taskId) => {
  return axios.get(`/PlannedMaintenance/GetSparePartsList?taskId=${taskId}`);
};

export const addSparePart = (payload) => {
  console.log("payload", payload);
  return axios.post(`/SpareParts/AddSparePart`, payload);
};

export const updateSparePart = (payload) => {
  return axios.put(`/SpareParts/UpdateSparePart`, payload);
};

export const deleteSparePart = (payload) => {
  return axios.delete(
    `/SpareParts/DeleteSparePart?sparePartId=${payload.sparePartId}`
  );
};

export const getPoolList = () => {
  return axios.get(`/Pool/GetList`);
};
export const saveSparePartBreakdown = (payload) => {
  return axios.post(
    `/UnplannedMaintenance/tasks/${payload.taskId}/spare-parts`,
    payload.sparePartList
  );
};

export const saveSparePartPlanned = (payload) => {
  return axios.post(
    `/PlannedMaintenance/tasks/${payload.taskId}/spare-parts`,
    payload.sparePartList
  );
};

export const getListStockCodesAndMaterialDescriptions = () => {
  return axios.get(`/SpareParts/GetListStockCodesAndMaterialDescriptions`);
};

export const saveSparePartLogs = (payload) => {
  return axios.post(`/SpareParts/SaveSparePartLogs`, payload);
};

export const addSparePartNote = (payload) => {
  console.log(payload);
  return axios.post(`/SpareParts/SaveSparePartNoteDefinition`, payload);
}

export const getSparePartNoteList = (payload) => {
  console.log(payload);
  const pageSize = payload?.payload?.pageSize ?? 10;
  const pageNumber = payload?.payload?.pageNumber ?? 1;
  const searchText = payload?.payload?.searchText ?? "";

  return axios.get(`/SpareParts/GetPagedSparePartNoteDefinitions?PageSize=${pageSize}&PageNumber=${pageNumber}&searchText=${searchText}`);
}

export const updateSparePartNote = (payload) => {
  return axios.put(`/SpareParts/UpdateSparePartNote`, payload)
}

export const deleteSparePartNote = (id) => {
  return axios.delete(`/SpareParts/DeleteSparePartNote?id=${id}`)
}
